module.exports = __webpack_public_path__ + "static/media/notificaction.96aff013.svg";